window.$attributes = $("[data-box-produto-main] [data-product-attributes]");

window.variants = {
  $wrapperProduct: $('[data-box-produto-main]'),
  config: {
    // pega o elemento que corresponde ao primeiro atributo
    $attr1: "",
    attr1Name: "",
    // pega o elemento que corresponde ao segundo atributo
    $attr2: "",
    attr2Name: "",
    // pega o elemento que corresponde ao terceiro atributo
    $attr3: "",
    attr3Name: "",
    // quantos atributos o produto tem para seleção
    qtdAttributes: 0,
    hasAttribute1: false,
    hasAttribute2: false,
    hasAttribute3: false,
  },
  setConfigDefault: function () {
    var _this = this;

    var $attr1 = $attributes.find('[data-attribute="1"]:not(.hidden)');
    var $attr2 = $attributes.find('[data-attribute="2"]:not(.hidden)');
    var $attr3 = $attributes.find('[data-attribute="3"]:not(.hidden)');

    var itensAttr1 = "";
    var itensAttr2 = "";
    var itensAttr3 = "";

    //console.log('$attr2', $attr2)

    if ($attr1.length > 0) {
      itensAttr1 = $attr1.data("items");
      itensAttr1 = itensAttr1.split(" // ");
      //itensAttr1.pop();
    }

    if ($attr2.length > 0) {
      itensAttr2 = $attr2.data("items");
      //console.log('itensAttr2', itensAttr2)
      itensAttr2 = itensAttr2.split(" // ");
      //console.log('itensAttr2', itensAttr2)
      //itensAttr2.pop();
    }

    if ($attr3.length > 0) {
      itensAttr3 = $attr3.data("items");
      itensAttr3 = itensAttr3.split(" // ");
      //itensAttr3.pop();
    }

    //console.log('itensAttr2', itensAttr2)

    $.extend(true, _this.config, {
      // pega o elemento que corresponde ao primeiro atributo
      $attr1: $attr1,
      attr1Name: $attr1.data("attribute-name"),
      itemsAttr1: itensAttr1,
      // pega o elemento que corresponde ao segundo atributo
      $attr2: $attr2,
      attr2Name: $attr2.data("attribute-name"),
      itemsAttr2: itensAttr2,
      // pega o elemento que corresponde ao terceiro atributo
      $attr3: $attr3,
      attr3Name: $attr3.data("attribute-name"),
      itemsAttr3: itensAttr3,
    });
  },
  setQtdAttributes: function () {
    // Seta quantos atributos o produto possuí para seleção

    var qtdAttributes = 0;

    var $input = $attributes.find("[data-quantidade-atributos]");

    var $attr1 = this.config.$attr1;
    var $attr2 = this.config.$attr2;
    var $attr3 = this.config.$attr3;

    // considerando que o tamanho é o primeiro atributo
    if ($attr1.length > 0) {
      qtdAttributes++;
      this.config.hasAttribute1 = true;
    }

    // considerando que a cor é o segundo atributo
    if ($attr2.length > 0) {
      qtdAttributes++;
      this.config.hasAttribute2 = true;
    }

    // considerando que o custom é o terceiro atributo
    if ($attr3.length > 0) {
      qtdAttributes++;
      this.config.hasAttribute3 = true;
    }

    this.config.qtdAttributes = qtdAttributes;
  },
  setDisponibility: function () {
    var _this = this;
    //console.info('setDisponibility');
    // console.info(_this.config);

    if (_this.config.qtdAttributes > 1) {
      // Para quando há o atributo 1 e o atributo 2
      if (_this.config.hasAttribute1 && _this.config.hasAttribute2) {
        // Itera todas as cores para verificar a disponibilidade
        for (var i = 0; i < _this.config.itemsAttr1.length; i++) {
          var cor = _this.config.itemsAttr1[i];
          var $cor = _this.config.$attr1.find(
            '[data-attribute-value="' + cor + '"]'
          );
          var objFind = {};
          var corAvailable = false;
          objFind[_this.config.attr1Name] = cor;

          // Busca todas as variações que contém a cor
          var results = vnda.variants.find(objFind);

          // Percorre todas as variantes com a cor
          for (var ii = 0; ii < results.length; ii++) {
            // Verifica se alguma variação tem a cor
            if (results[ii].available) {
              corAvailable = true;
            }
          }

          //console.log('$cor', $cor)
          //console.log('corAvailable', corAvailable)

          $cor.data("available", corAvailable);
          $cor.attr("data-available", corAvailable);

          if (corAvailable) {
            $cor.removeClass("unavailable");
            $cor.addClass("available");
          } else {
            $cor.removeClass("available");
            $cor.addClass("unavailable");
          }
        }
      }
    }
  },
  toggleOptionsStyle: function (_$option) {
    /*
      Define se o estilo do atributo passado por parametro é input ou dropdown
    */
    var selecao = _$option.data("selecao");
    var styleType = _$option.data("selecao-style");
    var $optionList = _$option.find("[data-attribute-value]");
    var show = true;
    var showStatusList = [];

    // console.info('atributo', selecao, styleType);

    $optionList.each(function (index, el) {
      var value = $(el).data("attribute-value");

      // console.info(value, value.length);
      if (selecao != "cor") {
        if (value.length > 4) {
          showStatusList[index] = true;
        } else {
          showStatusList[index] = false;
        }
      } else {
        if (value.indexOf("#") < 0) {
          showStatusList[index] = true;
        } else {
          showStatusList[index] = false;
        }
      }
    });

    if (showStatusList.indexOf(true) >= 0) {
      if (styleType == "input") {
        show = false;
      } else if (styleType == "dropdown") {
        show = true;
      }
    } else {
      if (styleType == "input") {
        show = true;
      } else if (styleType == "dropdown") {
        show = false;
      }
    }

    if (!show) {
      _$option.addClass("hidden");
    }
  },
  setAttributeValue: function (_value, _$attribute) {
    // console.info('setAttributeValue', _value, _$attribute);

    var attrName = _$attribute.data("attribute-name");
    var $input = _$attribute.find(
      'input[data-attribute-name="' + attrName + '"]'
    );

    $input.val(_value);
  },
  setAttributeValueSelected: function (_value, _$attribute) {
    // console.info('setAttributeValueSelected', _value, _$attribute);

    var $selected = _$attribute.find("[data-selected]");
    $selected.html(_value);
  },
  markFirstOption: function (_productBlock) {

    var _this = this;

    var $attr1 = this.config.$attr1;
    var $attr2 = this.config.$attr2;
    var $attr3 = this.config.$attr3;

    if (_productBlock){
      var $productBlock = $(_productBlock);
      $attr1 = $productBlock.find('[data-attribute="1"]:not(.hidden)');
      $attr2 = $productBlock.find('[data-attribute="2"]:not(.hidden)');
      $attr3 = $productBlock.find('[data-attribute="3"]:not(.hidden)');
    }

    //console.log($attr1.find('[data-attribute-value][data-available=true]').first());
    //console.log($attr2.find('[data-attribute-value][data-available=true]').first());
    //console.log($attr3.find('[data-attribute-value][data-available=true]').first());

    // atributo com dropdown
    if ($attr1.find('[data-attribute-value][data-available=true]').first().length > 0) {
      $attr1.find('[data-attribute-value][data-available=true]').first().trigger('click');
    } else {
      $attr1.find('[data-attribute-value]').first().trigger('click');
    }

    // if ($attr2.find('[data-attribute-value][data-available=true]').first().length > 0) {
    //   $attr2.find('[data-attribute-value][data-available=true]').first().trigger('click');
    // } else {
    //   $attr2.find('[data-attribute-value]').first().trigger('click');
    // }

    /*if ($attr3.find('[data-attribute-value][data-available=true]').first().length > 0) {
      $attr3.find('[data-attribute-value][data-available=true]').first().trigger('click');
    } else {
      $attr3.find('[data-attribute-value]').first().trigger('click');
    } */

  },
  getSkuAttributes: function () {
    var _this = this;
    var objFindVariant = {};
    var objVariant;

    if (_this.config.hasAttribute1) {
      var nameAttr1 = _this.config.attr1Name;
      var valueAttr1 = _this.config.$attr1
        .find('input[data-attribute-name="' + nameAttr1 + '"]')
        .val();
      objFindVariant[nameAttr1] = valueAttr1;
    }

    if (_this.config.hasAttribute2) {
      var nameAttr2 = _this.config.attr2Name;
      var valueAttr2 = _this.config.$attr2
        .find('input[data-attribute-name="' + nameAttr2 + '"]')
        .val();
      objFindVariant[nameAttr2] = valueAttr2;
    }

    if (_this.config.hasAttribute3) {
      var nameAttr3 = _this.config.attr3Name;
      var valueAttr3 = _this.config.$attr3
        .find('input[data-attribute-name="' + nameAttr3 + '"]')
        .val();
      objFindVariant[nameAttr3] = valueAttr3;
    }

    objVariant = vnda.variants.find(objFindVariant);

    console.info('objFindVariant', objFindVariant);
    console.info('objVariant', objVariant);

    return objVariant;
  },
  updatePrice: function (sale_price, price, installments) {
    if (sale_price != price) {
      var htmlPrice =
        "<del>" +
        store.formatMoney(price) +
        "</del> " +
        "<ins>" +
        store.formatMoney(sale_price) +
        "</ins>";
    } else {
      var htmlPrice = store.formatMoney(price);
    }
    $("[data-section-product] [data-update-price-main]").html(htmlPrice);
    $("[data-section-product] [data-update-installments]").html(
      `ou em ${installments.length}x de ${store.formatMoney(
        installments[installments.length - 1].price
      )}`
    );
  },
  // COMPORTAMENTO DE QUANDO O USUÁRIO SELECIONA UM ATRIBUTO
  setResultVariants: function () {
    console.log('SET RESULT VARIANTS')
    var _this = this;
    // busca a variante
    var objVariant = _this.getSkuAttributes();

    // console.info('objVariant', objVariant);

    if (objVariant.length > 0) {
      // seta o sku da variante que o usuário selecionou
      _this.$wrapperProduct.find('input[name="sku"]').val(objVariant[0].sku);

      // atualiza o preço do produto conforme a variante selecionada
      _this.updatePrice(
        objVariant[0].sale_price,
        objVariant[0].price,
        objVariant[0].installments
      );

      if ($("[data-form-notify]").length > 0) {
        $('[data-form-notify] input[name="sku"]').val(objVariant[0].sku);
      }
      // verifica se a variante selecionada está disponível ou não
      if (!objVariant[0].available) {
        _this.setProdutoIndisponivel(objVariant[0]);
      } else {
        _this.setProdutoDisponivel(objVariant[0]);
      }
    } else {
      _this.setProdutoIndisponivel(objVariant[0]);
    }

    if (objVariant.length > 0) {
      $attributes.find("[data-variant-selected]").html(objVariant[0].name);

      if (objVariant[0].properties.property1 && objVariant[0].properties.property1.name) {
        $attributes
          .find("[data-variant-" + objVariant[0].properties.property1.name + "]")
          .html(objVariant[0].properties.property1.value.split("|")[0]);
      }
     
      if (objVariant[0].properties.property2 && objVariant[0].properties.property2.name) {
        $attributes
          .find("[data-variant-" + objVariant[0].properties.property2.name + "]")
          .html(objVariant[0].properties.property2.value);
      }
      
      // PARA AS IMAGENS
      _this.setImagesProduct(objVariant[0].sku);
    }
  },
  setProdutoIndisponivel: function (_variant) {
    var _this = this;
    var $btnComprar = _this.$wrapperProduct.find(store.config.selectorBtnBuy);
    var textUnavailable = $btnComprar.data("text-unavailable");

    $btnComprar.data("available", "false");
    $btnComprar.removeClass("available");
    $btnComprar.addClass("unavailable");
    $btnComprar.html(textUnavailable);

    $btnComprar.css('pointer-events', 'none');

    // AVISE-ME QUANDO CHEGAR AQUI
    _this.setFormNotify(_variant);
  },
  setFormNotify: function (_variant) {
    var height = $("[data-form-notify]")
      .find(".form-wrapper")
      .outerHeight(true);

    $("[data-form-notify]").addClass("active").css("height", height);

    setTimeout(function () {
      $(document.body).trigger("sticky_kit:recalc");
    }, 500);

    if ($("[data-form-notify]").length > 0) {
      $('[data-form-notify] input[name="sku"]').val(_variant.sku);
    }
  },
  checkCombinations: function (_value, _attributeName) {
    var _this = this;
    var obj = {};
    obj[_attributeName] = String(_value);
    var results = vnda.variants.find(obj);

    //console.info('checkCombinations', _attributeName, _value);
    //console.info('results combinations', results);

    // Verifica a disponibilidade dos tamanhos quando uma cor é selecionada
    if (_this.config.attr1Name == _attributeName) {
      var tamanhos = _this.config.itemsAttr2;
      var objFind = {};
      objFind[_attributeName] = String(_value);

      //console.log('tamanhos', tamanhos)

      for (var i = 0; i < tamanhos.length; i++) {
        //console.log('String(tamanhos[i])', String(tamanhos[i]))

        objFind[_this.config.attr2Name] = String(tamanhos[i]);
        var corTamanhoResults = vnda.variants.find(objFind);

        var tamanho = tamanhos[i];
        var $tamanho = $('[data-attribute-value="' + tamanho + '"]');

        //console.info('corTamanhoResults', corTamanhoResults);

        if (corTamanhoResults.length > 0) {
          var variantResult = corTamanhoResults[0];
          var stock = variantResult.available_quantity;

          $tamanho.removeClass("disable");

          $tamanho.data("stock", stock);
          $tamanho.attr("data-stock", stock);

          if (variantResult.available) {
            $tamanho.data("available", true);
            $tamanho.attr("data-available", true);

            $tamanho.removeClass("unavailable");
            $tamanho.addClass("available");
          } else {
            $tamanho.data("available", false);
            $tamanho.attr("data-available", false);

            $tamanho.removeClass("available");
            $tamanho.addClass("unavailable");
          }
        } else {
          $tamanho.addClass("disable");
        }
      }
    }
  },
  setProdutoDisponivel: function () {
    var _this = this;
    var $btnComprar = window.variants.$wrapperProduct.find('.add-to-cart-button');
    var textAvailable = $btnComprar.data("text-available");

    $btnComprar.data("available", "true");
    $btnComprar.removeClass("unavailable");
    $btnComprar.addClass("available");
    $btnComprar.html(textAvailable);

    $btnComprar.css('pointer-events', 'all');

    $("[data-form-notify]").removeClass("active").css("height", 0);
  },
  /* 
    Exibe as imagens que contém o sku passado por parâmetro
  */
  setImagesProduct: function (_sku) {
    var $images = template_store.product.$wrapperImages;
    var $mainImages = template_store.product.$sliderProduct;
    var $thumbsImages = template_store.product.$thumbsProduct;
    var slideProduct = template_store.product.sliderProduct[0];
    var qtdImagesSku = $mainImages.find(
      '[data-skus-image*="' + _sku + ',"]'
    ).length;
    var $imagesWithoutSkus = $mainImages.find(".image-without-sku");
    var $thumbsWithoutSkus = $thumbsImages.find(".image-without-sku");

    //console.info($mainImages.find('[data-skus-image*="' + _sku + ',"]'));
    //console.info('[data-skus-image*="' + _sku + '"]');

    if (qtdImagesSku > 0) {
      // Esconde as imagens que não contém o sku
      $mainImages
        .find("[data-image][data-skus-image]")
        .removeClass("active")
        .addClass("inactive");

      $thumbsImages
        .find("[data-image-thumb][data-skus-image]")
        .removeClass("active")
        .addClass("inactive");

      // Mostra as imagens que contém o sku
      $mainImages
        .find('[data-image][data-skus-image*="' + _sku + ',"]')
        .addClass("active")
        .removeClass("inactive");

      $thumbsImages
        .find('[data-image-thumb][data-skus-image*="' + _sku + ',"]')
        .addClass("active")
        .removeClass("inactive");

      // As imagens sem skus selecionados são exibidas sempre
      $imagesWithoutSkus.removeClass("inactive").addClass("active");

      $thumbsWithoutSkus.removeClass("inactive").addClass("active");

      // $(document.body).trigger("sticky_kit:recalc");
      //console.log(slideProduct)
      slideProduct.update();
      slideProduct.slideTo(0);
    } else {
      $mainImages
        .find("[data-image][data-skus-image]")
        .removeClass("active")
        .addClass("inactive");

      $thumbsImages
        .find("[data-image-thumb][data-skus-image]")
        .removeClass("active")
        .addClass("inactive");

      $imagesWithoutSkus.removeClass("inactive").addClass("active");

      $thumbsWithoutSkus.removeClass("inactive").addClass("active");
    }
  },
  execActionAttr: function (_attrName, _valueSelected) {
    var _this = this;

    if (_this.config.attr1Name == _attrName) {
      if (typeof attr1Action == "function") {
        attr1Action(_valueSelected);
      }
    } else if (_this.config.attr2Name == _attrName) {
      if (typeof attr2Action == "function") {
        attr2Action(_valueSelected);
      }
    } else if (_this.config.attr3Name == _attrName) {
      if (typeof attr3Action == "function") {
        attr3Action(_valueSelected);
      }
    }
  },
  init: function () {
    var _this = this;

    _this.setConfigDefault();
    _this.setQtdAttributes();

    let firstChanged = true

    console.log('this.config', this.config.qtdAttributes)

    // DEFINE SE O QUE VAI APARECER É A OPÇÃO EM INPUT RADIO OU O DROPDOWN
    $attributes.find("[data-prod-option]").each(function (index, el) {
      // _this.toggleOptionsStyle($(el));
    });

    $attributes.on(
      "click",
      "[data-prod-option]:not(.hidden) [data-attribute-value]",
      function (event) {
        if ($(this).is("a")) {
          event.preventDefault();
        }

        var $wrapperAttribute = $(this).closest("[data-prod-option]");

        if (_this.config.qtdAttributes == 1){
          firstChanged = false
        }

        var selecao = $wrapperAttribute.data("selecao");
        var selecaoStyle = $wrapperAttribute.data("selecao-style");
        var attrName = $wrapperAttribute.data("attribute-name");
        var value = $(this).data("attribute-value");

        // console.info('selecao value', selecao, attrName, value);

        _this.setAttributeValue(value, $wrapperAttribute);
        _this.setAttributeValueSelected(value, $wrapperAttribute);

        
        if (firstChanged == false){
          _this.checkCombinations(value, attrName);
          _this.execActionAttr(attrName, value);
          _this.setResultVariants();
        }
        

        if ($($wrapperAttribute).data("attribute-name") == 'Cor'){
          firstChanged = false
        }
      }
    );

    console.log('_this.qtdAttributes: ', _this.config.qtdAttributes);

    if (_this.config.qtdAttributes == 0) {
      var variant = vnda.variants.all()[0];
      console.log(variant);
      if (!variant.available) {
        console.log('if')
        _this.setProdutoIndisponivel(variant);
      } else {
        console.log('else')
        _this.setProdutoDisponivel(variant);
      }
    }

    
    _this.setDisponibility();
    _this.markFirstOption();
  },
};

function attr1Action(_valueSelected) {
  var $attr1 = variants.config.$attr1;
  var $attr2 = variants.config.$attr2;
  var $attr3 = variants.config.$attr3;

  //console.log($attr1.find('[data-attribute-value][data-available=true]').first());
  //console.log($attr2.find('[data-attribute-value][data-available=true]').first());
  //console.log($attr3.find('[data-attribute-value][data-available=true]').first());

  if (
    $attr2
      .find("[data-attribute-value][data-available=true]:not(.disable)")
      .first().length > 0
  ) {
    //console.log('THIS', $attr2.find('[data-attribute-value][data-available=true]:not(.disable)').first())
    $attr2
      .find("[data-attribute-value][data-available=true]:not(.disable)")
      .first()
      .trigger("click");
  } else if (
    $attr2.find("[data-attribute-value][data-available=true]").first().length >
    0
  ) {
    $attr2
      .find("[data-attribute-value][data-available=true]")
      .first()
      .trigger("click");
  } else {
    $attr2.find("[data-attribute-value]").first().trigger("click");
  }
}

function attr2Action(_valueSelected) {
  var $attr1 = variants.config.$attr1;
  var $attr2 = variants.config.$attr2;
  var $attr3 = variants.config.$attr3;

  //console.log($attr1.find('[data-attribute-value][data-available=true]').first());
  //console.log($attr2.find('[data-attribute-value][data-available=true]').first());
  //console.log($attr3.find('[data-attribute-value][data-available=true]').first());

  if (
    $attr3
      .find("[data-attribute-value][data-available=true]:not(.disable)")
      .first().length > 0
  ) {
    //console.log('THIS', $attr3.find('[data-attribute-value][data-available=true]:not(.disable)').first())
    $attr3
      .find("[data-attribute-value][data-available=true]:not(.disable)")
      .first()
      .trigger("click");
  } else if (
    $attr3.find("[data-attribute-value][data-available=true]").first().length >
    0
  ) {
    $attr3
      .find("[data-attribute-value][data-available=true]")
      .first()
      .trigger("click");
  } else {
    $attr3.find("[data-attribute-value]").first().trigger("click");
  }
}

$(function () {
  if (page == "product") {
    window.variants.init();
  }
});
